import type { ApiFetchGameFiltersPort } from '~/handlers/ports/api-fetch-game-filters.port';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';

export class ApostatudoApiFetchGameFiltersAdapter
  implements ApiFetchGameFiltersPort
{
  async handle(params: GameFiltersParams): Promise<GameFiltersApiResponse> {
    // Construir query string a partir dos parâmetros
    const queryParams = new URLSearchParams();

    // Adicionar categorias (filtrar "all" e valores vazios)
    if (params.categories && params.categories.length > 0) {
      const validCategories = params.categories.filter(
        (category) => category && category.toLowerCase() !== 'all',
      );

      validCategories.forEach((category) => {
        queryParams.append('categories[]', category);
      });
    }

    // Adicionar providers (filtrar "all" e valores vazios)
    if (params.providers && params.providers.length > 0) {
      const validProviders = params.providers.filter(
        (provider) => provider && provider.toLowerCase() !== 'all',
      );

      validProviders.forEach((provider) => {
        queryParams.append('providers[]', provider);
      });
    }

    // Adicionar termo de busca (trim para remover espaços)
    if (params.term && params.term.trim()) {
      queryParams.append('term', params.term.trim());
    }

    // Adicionar ordenação (apenas se não for vazio)
    if (params.sort && params.sort.trim()) {
      queryParams.append('sort', params.sort.trim());
    }

    // Adicionar tipos de jogo (filtrar valores vazios)
    if (params.types && params.types.length > 0) {
      const validTypes = params.types.filter((type) => type && type.trim());

      validTypes.forEach((type) => {
        queryParams.append('types[]', type);
      });
    }

    // Adicionar sort_by (apenas se não for vazio)
    if (params.sort_by && params.sort_by.trim()) {
      queryParams.append('sort_by', params.sort_by.trim());
    }

    // Adicionar sort_dir (apenas se não for vazio)
    if (params.sort_dir && params.sort_dir.trim()) {
      queryParams.append('sort_dir', params.sort_dir.trim());
    }

    // Jogar com Bonus: so os elegiveis. O core aceita 1/0/true/false e trata
    // ausente como "sem filtro", entao so mandamos quando pedido.
    if (params.bonus_eligible === true) {
      queryParams.append('bonus_eligible', '1');
    }

    // Adicionar paginação
    queryParams.append('page', String(params.page || 1));
    queryParams.append('per_page', String(params.per_page || 24));

    const queryString = queryParams.toString();
    const url = `${getApostatudoApiUrl()}/games/filter${queryString ? `?${queryString}` : ''}`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }

    const result: GameFiltersApiResponse = await response.json();

    // FALHA FECHADA. Param desconhecido e ignorado em silencio pelo Laravel: se
    // esta versao da API ainda nao tem o filtro, a resposta volta com o
    // catalogo inteiro — e uma tela "Jogar com Bonus" listando jogo que nao
    // aceita bonus e pior do que uma tela vazia. Entao, quando o filtro foi
    // pedido, so passam os itens que o proprio payload confirma elegiveis.
    //
    // Nao e re-filtragem de paginacao: com a API suportando o filtro nenhum
    // item cai aqui e a paginacao do servidor continua intacta. Isso so tem
    // efeito quando a resposta nao respeitou o pedido (API antiga, cache velho
    // ou fallback JSON sem o campo), e ai o efeito desejado e listar zero.
    if (params.bonus_eligible === true && Array.isArray(result?.data)) {
      const eligible = result.data.filter(
        (game) => (game as FilteredGame)?.bonus_eligible === true,
      );

      if (eligible.length !== result.data.length) {
        console.warn(
          '[apiFetchGameFilters] resposta ignorou bonus_eligible: ' +
            `${result.data.length - eligible.length} de ${result.data.length} itens descartados`,
        );
      }

      return { ...result, data: eligible };
    }

    return result;
  }
}
